/** Loading clean das abas/telas do ERP: barra horizontal centralizada. */
export function PageContentLoader({ className = "" }: { className?: string }) {
  return (
    <div
      className={`flex min-h-[min(70vh,32rem)] w-full flex-1 items-center justify-center ${className}`.trim()}
      role="status"
      aria-label="Carregando"
      aria-busy="true"
    >
      <div className="gs-page-content-loader-track">
        <div className="gs-page-content-loader-bar" />
      </div>
    </div>
  );
}
